// 页面需要用到的组件
import Vue from 'vue';
import { DatePicker } from 'mand-mobile';

// import { Dialog, CellGroup, Cell, Tag, CheckboxGroup, Toast, Overlay, Rate, Progress, Uploader, List, Popup, DatetimePicker, ActionSheet, Swipe, Calendar, SwipeItem, Picker, Button, Field, Icon, Tab, Tabs, Image, Checkbox, RadioGroup, Radio, ImagePreview, Loading, Search, Switch, Grid, GridItem, Skeleton, PullRefresh,  } from 'vant';
import {
  Area,
  Form,
  Collapse,
  CollapseItem,
  Dialog,
  CellGroup,
  Cell,
  Tag,
  CheckboxGroup,
  Toast,
  Overlay,
  Rate,
  Progress,
  Uploader,
  List,
  Popup,
  DatetimePicker,
  ActionSheet,
  Swipe,
  Calendar,
  SwipeItem,
  Picker,
  Button,
  Field,
  Icon,
  Tab,
  Tabs,
  Image,
  Checkbox,
  RadioGroup,
  Radio,
  ImagePreview,
  Loading,
  Search,
  Switch,
  Grid,
  GridItem,
  Skeleton,
  PullRefresh,
  IndexBar,
  IndexAnchor,
  Steps,
  Step,
  TreeSelect,
  Popover,
  Divider,
  Empty,
  Cascader
} from 'vant';
import SvgIcon from '@/components/SvgIcon.vue';
Vue.use(TreeSelect);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Toast);
Vue.use(Area);
Vue.prototype.$Toast = Toast;
Vue.prototype.$Dialog = Dialog;
// ImagePreview
Vue.prototype.$ImagePreview = ImagePreview;
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Form);
Vue.use(Field);
Vue.use(Divider);
Vue.use(Empty);
Vue.use(Cascader);
Vue.component('van-dialog', Dialog);
Vue.component('van-uploader', Uploader);
Vue.component('CellGroup', CellGroup);
Vue.component('Cell', Cell);
Vue.component('van-checkbox-group', CheckboxGroup);
Vue.component('van-list', List);
Vue.component('van-popup', Popup);
Vue.component('van-datetime-picker', DatetimePicker);
Vue.component('van-picker', Picker);
Vue.component('md-date-picker', DatePicker);
Vue.component('van-swipe-item', SwipeItem);
Vue.component('van-swipe', Swipe);
Vue.component('van-button', Button);
Vue.component('van-rate', Rate);
Vue.component('van-field', Field);
Vue.component('van-uploader', Uploader);
Vue.component('van-icon', Icon);
Vue.component('van-tab', Tab);
Vue.component('van-tabs', Tabs);
Vue.component('van-image', Image);
Vue.component('van-overlay', Overlay);
Vue.component('van-checkbox', Checkbox);
Vue.component('van-RadioGroup', RadioGroup);
Vue.component('van-Radio', Radio);
Vue.component('van-loading', Loading);
Vue.component('van-search', Search);
Vue.component('van-action-sheet', ActionSheet);
Vue.component('van-switch', Switch);
Vue.component('van-progress', Progress);
Vue.component('van-grid', Grid);
Vue.component('van-grid-item', GridItem);
Vue.component('van-tag', Tag);
Vue.component('van-skeleton', Skeleton);
Vue.component('van-pull-refresh', PullRefresh);
Vue.component('van-calendar', Calendar);
Vue.component('van-steps', Steps);
Vue.component('van-step', Step);
Vue.component('van-index-bar', IndexBar);
Vue.component('van-index-anchor', IndexAnchor);
Vue.component('van-popover', Popover);
// Vue.component('van-image-preview', ImagePreview);

Vue.component('svg-icon', SvgIcon);
